import React from 'react';

const TaskListPagination = ({ pagination, onPageChange, loading = false }) => {
    const { page = 1, totalPages = 1, total = 0, limit = 15 } = pagination || {};
    const safeTotalPages = Math.max(1, totalPages);
    const canPrev = page > 1 && !loading;
    const canNext = page < safeTotalPages && !loading;

    if (total <= limit && safeTotalPages <= 1) {
        return null;
    }

    const start = total === 0 ? 0 : (page - 1) * limit + 1;
    const end = Math.min(page * limit, total);

    return (
        <div className="flex flex-col gap-3 border-t border-zinc-100 pt-4 dark:border-zinc-800 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-zinc-500 dark:text-zinc-400">
                Showing {start}–{end} of {total} task{total === 1 ? '' : 's'}
            </p>
            <div className="flex items-center gap-2">
                <button
                    type="button"
                    disabled={!canPrev}
                    onClick={() => onPageChange(page - 1)}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-zinc-200 bg-white px-3 py-1.5 text-xs font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-200 dark:hover:bg-zinc-800"
                >
                    <i className="fa-solid fa-chevron-left text-[10px]" aria-hidden />
                    Previous
                </button>
                <span className="min-w-[4.5rem] text-center text-xs font-medium tabular-nums text-zinc-600 dark:text-zinc-400">
                    {page} / {safeTotalPages}
                </span>
                <button
                    type="button"
                    disabled={!canNext}
                    onClick={() => onPageChange(page + 1)}
                    className="inline-flex items-center gap-1.5 rounded-lg border border-zinc-200 bg-white px-3 py-1.5 text-xs font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-40 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-200 dark:hover:bg-zinc-800"
                >
                    Next
                    <i className="fa-solid fa-chevron-right text-[10px]" aria-hidden />
                </button>
            </div>
        </div>
    );
};

export default TaskListPagination;
